import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m16.412 16.24 1.587-1.468a.53.53 0 0 0 .027-.736c-.655-.764-.852-1.401-.852-1.862V6.046c.007-1.025-.973-3.076-4.945-3.076-3.538 0-4.826 2.1-5.115 3.495-.055.263.148.496.416.52l2.09.189c.255.023.483-.152.583-.387.26-.61.867-1.383 2.026-1.383 1.168 0 1.577.895 1.635 1.343V8.13c-5.724 0-7.204 2.492-7.204 4.867s1.733 3.563 3.855 3.563c1.409 0 2.709-.777 3.43-1.364a.55.55 0 0 1 .723.014l1.057 1.022a.5.5 0 0 0 .687.008m-3.53-2.578c1.283-.976.988-3.699.988-3.699s-2.412-.16-3.354 1.287c-.514.79-.348 1.862.275 2.412.519.458 1.392.532 2.091 0m8.949 3.373c-.155-.176-.868-.115-1.553-.057-.68.058-1.332.113-1.384-.067-.105-.361 3.165-1.198 3.973-.542.703.57-1.112 3.935-1.612 3.664-.1-.054.05-.461.232-.963.274-.751.626-1.716.344-2.035m-9.824 2.313c-4.527 0-7.771-1.568-9.447-2.378-.701-.339-1.127-.545-1.258-.447-.441.33 4.724 4.414 10.705 4.414 5.231 0 9.756-2.825 9.094-3.2-.237-.134-.733.033-1.534.304-1.442.486-3.872 1.307-7.56 1.307",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandAmazon = { render };
export {
  brandAmazon as default,
  render
};
//# sourceMappingURL=brand-amazon.svg.js.map
